var _style, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKineo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 183",
    style: {
      enableBackground: "new 0 0 512 183"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000138564035743893796940000018311626251113445764_);}\r\n\t.st2{fill:url(#SVGID_00000006678279281989337500000015920999198954770581_);}\r\n\t.st3{opacity:0.7;fill:url(#SVGID_00000103974126331395980360000013941341069611654048_);}\r\n\t.st4{fill:url(#SVGID_00000107559286523755235940000003601628048690336397_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.2,156.8v11h14.5v2.6H66.2v11.9h-3v-28h19.2v2.6H66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5,154.2h3v28h-3V154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.9,154.2v28h-2.4l-18-22.7v22.7h-3v-28h2.4l18,22.7v-22.7H123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,174.7H135l-3.4,7.5h-3.1l12.8-28h2.9l12.8,28h-3.1L150.6,174.7z M149.5,172.3l-6.7-15l-6.7,15H149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,154.2v28h-2.4l-18-22.7v22.7h-3v-28h2.4l18,22.7v-22.7H185z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,180.6c-2.2-1.2-4-2.9-5.2-5.1c-1.3-2.2-1.9-4.6-1.9-7.3s0.6-5.1,1.9-7.3c1.3-2.2,3-3.9,5.3-5.1 c2.2-1.2,4.7-1.8,7.5-1.8c2.1,0,4,0.3,5.8,1c1.8,0.7,3.2,1.7,4.5,3l-1.9,1.9c-2.2-2.2-4.9-3.3-8.3-3.3c-2.2,0-4.2,0.5-6,1.5 c-1.8,1-3.2,2.4-4.3,4.2s-1.5,3.7-1.5,5.9s0.5,4.2,1.5,5.9c1,1.8,2.4,3.1,4.3,4.2c1.8,1,3.8,1.5,6,1.5c3.4,0,6.1-1.1,8.3-3.4 l1.9,1.9c-1.2,1.3-2.7,2.4-4.5,3.1c-1.8,0.7-3.7,1.1-5.8,1.1C203.5,182.4,201,181.8,198.8,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,179.6v2.6h-19.8v-28H242v2.6h-16.2v9.9h14.5v2.5h-14.5v10.4H242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.1,154.2v28h-2.8v-22.4l-11,18.8h-1.4l-11-18.7v22.2h-2.8v-28h2.4l12.1,20.7l12-20.7H289.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,174.7h-15.6l-3.4,7.5h-3.1l12.8-28h2.9l12.8,28h-3.1L315.7,174.7z M314.7,172.3l-6.7-15l-6.7,15H314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,182.2l-6.4-9c-0.7,0.1-1.5,0.1-2.2,0.1h-7.5v8.9h-3v-28h10.5c3.6,0,6.4,0.9,8.4,2.6c2,1.7,3,4,3,7 c0,2.2-0.6,4-1.7,5.5c-1.1,1.5-2.7,2.6-4.7,3.3l6.8,9.6H345.9z M343.6,168.9c1.5-1.2,2.2-2.9,2.2-5.2c0-2.3-0.7-4-2.2-5.2 c-1.5-1.2-3.6-1.8-6.4-1.8h-7.4v14h7.4C340,170.8,342.1,170.2,343.6,168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.4,169l-5.7,5.8v7.3h-3v-28h3v16.9l16.4-16.9h3.4l-12.1,12.7l12.9,15.3h-3.5L364.4,169z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,179.6v2.6h-19.8v-28h19.2v2.6h-16.2v9.9h14.5v2.5h-14.5v10.4H403.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.3,156.8h-9.8v-2.6H429v2.6h-9.8v25.4h-3V156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.1,181.4c-1.9-0.7-3.4-1.5-4.4-2.6l1.2-2.3c1,1,2.4,1.8,4,2.5c1.7,0.6,3.4,0.9,5.2,0.9c2.5,0,4.4-0.5,5.6-1.4 c1.3-0.9,1.9-2.1,1.9-3.6c0-1.1-0.3-2-1-2.7c-0.7-0.7-1.5-1.2-2.5-1.5c-1-0.4-2.4-0.8-4.1-1.2c-2.1-0.5-3.8-1-5-1.5 c-1.3-0.5-2.3-1.2-3.2-2.3c-0.9-1-1.3-2.4-1.3-4.1c0-1.4,0.4-2.7,1.1-3.9c0.7-1.2,1.9-2.1,3.4-2.8c1.5-0.7,3.5-1,5.8-1 c1.6,0,3.2,0.2,4.7,0.7c1.5,0.4,2.9,1,4,1.8l-1,2.4c-1.2-0.8-2.4-1.3-3.8-1.7c-1.3-0.4-2.6-0.6-3.9-0.6c-2.4,0-4.3,0.5-5.5,1.4 c-1.2,0.9-1.9,2.2-1.9,3.7c0,1.1,0.3,2,1,2.7c0.7,0.7,1.5,1.2,2.6,1.6c1,0.4,2.4,0.8,4.1,1.2c2,0.5,3.7,1,5,1.5 c1.3,0.5,2.3,1.2,3.2,2.2c0.9,1,1.3,2.4,1.3,4.1c0,1.4-0.4,2.7-1.1,3.9c-0.8,1.2-1.9,2.1-3.5,2.8c-1.6,0.7-3.5,1-5.8,1 C438.9,182.4,437,182.1,435.1,181.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.2,22.6h28.2v99.8h-28.2V22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,22.6v99.8h-23.2l-44.1-53.2v53.2h-27.7V22.6h23.2l44.1,53.2V22.6H290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.6,100.6v21.8h-80.1V22.6h78.3v21.8h-50.3v16.8h44.4v21.1h-44.4v18.3H390.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.1,117.7c-8.4-4.5-15-10.6-19.8-18.5c-4.8-7.9-7.2-16.8-7.2-26.7c0-9.9,2.4-18.8,7.2-26.7 c4.8-7.9,11.4-14.1,19.8-18.5c8.4-4.5,17.9-6.7,28.5-6.7c10.6,0,20,2.2,28.5,6.7c8.4,4.5,15,10.7,19.8,18.5 c4.8,7.9,7.2,16.8,7.2,26.7c0,9.9-2.4,18.8-7.2,26.7c-4.8,7.9-11.4,14.1-19.8,18.5c-8.4,4.5-17.9,6.7-28.5,6.7 C446,124.4,436.5,122.2,428.1,117.7z M470.2,97.5c4.1-2.4,7.3-5.7,9.7-10.1c2.4-4.3,3.6-9.3,3.6-14.9c0-5.6-1.2-10.6-3.6-14.9 c-2.4-4.3-5.6-7.7-9.7-10.1c-4.1-2.4-8.7-3.6-13.7-3.6c-5,0-9.6,1.2-13.7,3.6c-4.1,2.4-7.3,5.7-9.7,10.1 c-2.4,4.3-3.6,9.3-3.6,14.9c0,5.6,1.2,10.6,3.6,14.9c2.4,4.3,5.6,7.7,9.7,10.1c4.1,2.4,8.6,3.6,13.7,3.6 C461.6,101,466.1,99.8,470.2,97.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.2982,
    y1: 56.6247,
    x2: 34.3671,
    y2: 16.9691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4A362"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,52.3l3.7-17.6L72.9,0H26.2L7.1,90.4C20.2,77.7,38.2,63.7,61.8,52.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116227447079548830320000010055887653687293833_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.7495,
    y1: 42.9345,
    x2: 102.8184,
    y2: 3.2789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4A362"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116227447079548830320000010055887653687293833_)"
    },
    d: "M117.4,34.1L152.7,0h-44.5 C103,0,98,2.1,94.4,5.8L81.8,18.4C72.4,27.8,65.6,39.5,62,52.2C77.9,44.6,96.3,38.2,117.4,34.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134946732987306228050000006870587665789792403_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.0315,
    y1: 89.9581,
    x2: 122.7386,
    y2: 125.908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4A362"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134946732987306228050000006870587665789792403_)"
    },
    d: "M58.4,68.8l-4.8,22.9L64.6,81l11.6,30.6 c2.9,7.6,10.1,12.6,18.2,12.6h35.9L99.9,52.3C84.8,57.3,70.2,62.8,58.4,68.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002366801609518263720000015398994675119345548_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.5017,
    y1: 115.4133,
    x2: 79.3352,
    y2: 75.0367
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4A362"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000002366801609518263720000015398994675119345548_)"
    },
    d: "M57.8,71.4l-4.3,20.3 L64.6,81l11.6,30.6c2.9,7.6,10.1,12.6,18.2,12.6h35.9L99.5,51.6C85.5,58,71.7,64.7,57.8,71.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009577908592407009320000018079142584421589938_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 77.2,
    x2: 276.7268,
    y2: 77.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E5C376"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4A362"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009577908592407009320000018079142584421589938_)"
    },
    d: "M0,124.2c0,0,65.8-137.8,276.7-79.7 c0,0-107.2-27.7-188.7,27.8C56.2,94,46.7,124.2,46.7,124.2H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKineo);
export default __webpack_public_path__ + "static/media/kineo.e440ab9772b1c6b5438bd14cdb0bc424.svg";
export { ForwardRef as ReactComponent };